import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { useStations } from '../data/catalog'
import { type Station } from '../data/stations'
import { Seo } from '../seo/Seo'
import {
  breadcrumbSchema,
  stationsItemListSchema,
  websiteSchema,
} from '../seo/schema'
import './Stations.css'

function StationTile({ station, index }: { station: Station; index: number }) {
  return (
    <li
      className="stations__item"
      style={{ animationDelay: `${80 + index * 40}ms` }}
    >
      <Link
        className="stations__link"
        to={`/stations/${station.slug}`}
        aria-label={`${station.name} Jewish music radio`}
      >
        <img
          src={station.icon}
          alt=""
          width={88}
          height={88}
          loading="lazy"
        />
        <h3>{station.name}</h3>
      </Link>
    </li>
  )
}

export function Stations() {
  const stations = useStations()

  return (
    <main className="stations shell">
      <Seo
        title="Jewish Music Radio Stations"
        description={`Browse ${stations.length} free Jewish music radio stations. Stream Yiddish, sefira vocals, kumzitz, chazzanus, and new Jewish music live 24/6.`}
        path="/stations"
        keywords={[
          'jewish music stations',
          'jewish radio stations',
          'jewish music radio',
          'stream jewish music',
          'free jewish radio stations',
        ]}
        jsonLd={[
          websiteSchema(),
          stationsItemListSchema(),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Stations', path: '/stations' },
          ]),
        ]}
      />

      <Breadcrumbs
        items={[
          { name: 'Home', path: '/' },
          { name: 'Stations' },
        ]}
      />

      <header className="stations__header">
        <h1>Jewish music radio stations</h1>
      </header>

      <ul className="stations__grid">
        {stations.map((station, index) => (
          <StationTile key={station.slug} station={station} index={index} />
        ))}
      </ul>

      <p className="stations__crawl" aria-hidden="true">
        Browse {stations.length} free Jewish music radio stations and stream Yiddish, sefira vocals, kumzitz, chazzanus, simcha, and new Jewish music live 24/6: {stations.map((station) => station.name).join(', ')}.
      </p>
    </main>
  )
}
